export enum DepartmentEndpoints {
  FetchDepartments = '/departments',
}
